@if (breadcrumbs$ | async; as bc) {
  @if (bc.length !== 0) {
    <div class="breadcrumbs-container">
      <tui-breadcrumbs size="m">
        @for (item of bc; let i = $index; track i) {
          <a *tuiItem tuiLink [routerLink]="item.routerLink">{{ item.caption }}</a>
        }
      </tui-breadcrumbs>
    </div>
  }
}
